import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faSignOutAlt} from '@netx/core-icons';
import {canCheckOut} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionCheckoutIcon = faSignOutAlt;

/**
 * Checkin asset
 * @param params
 * @returns Action
 */
export const assetActionCheckout = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-checkout',
	cb: () => dispatcher.trigger(ASSET_EVENT.CHECKOUT, asset),
	enableTest: () => canCheckOut(asset),
	get label() {
		return AssetActionLabel.CHECKOUT;
	},
	icon: assetActionCheckoutIcon,
	...params,
});

export default assetActionCheckout;
